import React, { useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import KeywordLineChartWrapper from "./KeywordLineChartWrapper";
import RelatedKeywordChartWrapper from "./RelatedKeywordChartWrapper";
import RelatedAdjectivesChartWrapper from "./RelatedAdjectivesChartWrapper";
import RelatedTopicsChartWrapper from "./RelatedTopicsChartWrapper";
import { PageHeader } from "../../../components/PageHeader";
import { useTranslation } from "react-i18next";
import { getFromStorage } from "../../../util/StorageUtil";

function KeywordStatisticsPage() {
  const [keyword, setKeyword] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );
  const [keywordToSend, setKeywordToSend] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );
  const { t } = useTranslation(["common", "keyword"]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  };
  return (
    <Grid container spacing={2} sx={{ marginTop: "0px" }}>
      <PageHeader
        text={t("keyword:keyword_basic_stats") + ":"}
        supplement={
          <TextField
            variant="outlined"
            id="wordcloud-box-input"
            sx={{ width: "240px", height: "35px", margin: "0 16px"}}
            value={keyword}
            inputProps={{ style: { textAlign: "right",  padding: "0 8px"  } }}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setKeywordToSend(keyword.trim());
              }
            }}
          />
        }
      />
      <Grid item xs={0.75}></Grid>
      <Grid item xs={5.25} className="grid-border white slide-from-left">
        <KeywordLineChartWrapper keyword={keywordToSend} x={10} />
      </Grid>
      <Grid item xs={0.25}></Grid>
      <Grid item xs={5.25} className="grid-border white slide-from-right">
        <RelatedTopicsChartWrapper keyword={keywordToSend} time={10} />
      </Grid>
      <Grid item xs={0.25}></Grid>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={5.25} className="grid-border white slide-from-left">
        <RelatedAdjectivesChartWrapper keyword={keywordToSend} time={10} />
      </Grid>
      <Grid item xs={0.25}></Grid>
      <Grid item xs={5.25} className="grid-border white slide-from-right">
        <RelatedKeywordChartWrapper keyword={keywordToSend} time={10} />
      </Grid>
    </Grid>
  );
}
export default KeywordStatisticsPage;
